export default {
    props: {
        messagesApply: {
            type: String,
            kComposite: 'messages.apply'
        }, 
        messagesCancel: {
            type: String,
            kComposite: 'messages.cancel'
        }, 
        messagesPreviewInput: {
            type: String,
            kComposite: 'messages.previewInput'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoColorPicker/Messages.js